import * as Popover from '@radix-ui/react-popover';
import classNames from 'classnames';
import React from 'react';

import { Button } from '@wetransfer/ux-components';

import { Pill } from '@wetransfer/transfer/oneui/react';

import { CaretUpIcon } from './CaretUpIcon';
import {
  ACCEPT_BUTTON_TEXT,
  DESCRIPTION_TEXT,
  DISMISS_BUTTON_TEXT,
  PILL_TEXT,
} from './constants';
import styles from './OptionsCustomWallpaperUpsellPopover.module.scss';
import { OptionsCustomWallpaperUpsellPopoverProps } from './types';
import { preventDefault } from './utils';

export default function OptionsCustomWallpaperUpsellPopover({
  target,
  onDismissPopover,
  onAcceptPopover,
}: OptionsCustomWallpaperUpsellPopoverProps) {
  return (
    <Popover.Root open>
      <Popover.Anchor asChild>{target}</Popover.Anchor>
      <Popover.Portal>
        <Popover.Content
          className={styles.content}
          sideOffset={7}
          align="start"
          alignOffset={-38}
          onOpenAutoFocus={preventDefault}
          onInteractOutside={onDismissPopover}
        >
          <Pill
            textContent={PILL_TEXT}
            variant="highlight"
            shape="square"
            size="small"
            className={styles.pill}
          />
          <p className={styles.description}>{DESCRIPTION_TEXT}</p>
          <div className={styles.buttonRow}>
            <Button
              appearance="secondary"
              size="small"
              onClick={onAcceptPopover}
              className={classNames(styles.button, styles.acceptButton)}
            >
              {ACCEPT_BUTTON_TEXT}
            </Button>
            <Button
              appearance="tertiary"
              variation="neutral"
              size="small"
              onClick={onDismissPopover}
              className={classNames(styles.button, styles.dismissButton)}
            >
              {DISMISS_BUTTON_TEXT}
            </Button>
          </div>
          <Popover.Arrow asChild width={28} height={9}>
            <CaretUpIcon className={styles.arrowIcon} />
          </Popover.Arrow>
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
}
